import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { InstallationsService, UserImp } from '@ubie/core';
import { FeedbackService } from '@ubie/shared';

@Component({
  selector: 'acl-owner-modal',
  standalone: false,
  templateUrl: './owner-modal.component.html',
  styleUrl: './owner-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerModalComponent implements OnInit {
  private readonly modalController = inject(ModalController);
  private readonly formBuilder = inject(FormBuilder);
  private readonly installationsService = inject(InstallationsService);
  private readonly feedbackService = inject(FeedbackService);

  installationOwner: UserImp | undefined;
  ownerForm: FormGroup | undefined;
  readonly _installationId = signal<number>(0);

  @Input() set installationId(value: number) {
    this._installationId.set(value);
  }

  ngOnInit(): void {
    this.ownerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  // when popup dismiss
  async dismiss(event: string): Promise<void> {
    this.modalController.dismiss(event);
  }

  onSubmitOwnerAdd(): void {
    if (this.ownerForm?.valid) {
      this.deliverInstallation(this._installationId());
    }
  }

  deliverInstallation(installationId: number): void {
    const obj = { ...this.installationOwner, ...this.ownerForm?.value };

    this.installationsService
      .deliverInstallation(installationId, obj)
      .subscribe({
        next: () => {
          this.dismiss('success');
        },
        error: (error) => {
          this.feedbackService.present(
            error.error.errorMessage,
            5000,
            true,
            'danger',
          );
        },
      });
  }
}
